import { Fade, Tooltip, type TooltipProps } from '@mui/material';

export const tooltipSlotProps = {
  arrow: {
    sx: {
      color: '#3e3e3e',
    },
  },
  popper: {
    sx: {
      '& .MuiTooltip-tooltip': {
        padding: '4px 8px 5px 8px',
      },
      '&.MuiTooltip-popper[data-popper-placement*="bottom"] .MuiTooltip-tooltip': {
        marginTop: '6px',
      },
    },
    modifiers: [
      {
        name: 'offset',
        options: {
          offset: [0, 3],
        },
      },
    ],
  },
  tooltip: {
    sx: {
      fontFamily: 'var(--font)',
      fontSize: 12.5,
      backgroundColor: '#3e3e3e',
    },
  },
} satisfies TooltipProps['slotProps'];

export const tooltipSlots = {
  transition: Fade,
} satisfies TooltipProps['slots'];

export const ConditionalToolTip = ({ children, enabled, ...props }: TooltipProps & { enabled: boolean }) => {
  if (!props.title || !enabled) return children;
  return (
    <Tooltip {...props}>
      <span>{children}</span>
    </Tooltip>
  );
};
